"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = require("react");

const styles_1 = require("./styles");

const Checkbox = props => {
  const {
    isDisabled,
    isChecked,
    indeterminate = false,
    onChange = () => {},
    label,
    checkboxBg,
    checkboxBgActive,
    checkboxBgDisabled,
    checkboxBorderColor,
    checkMarkColor
  } = props;
  const checkboxRef = (0, react_1.useRef)(null);

  const handleOnChange = e => {
    if (isDisabled) {
      return;
    }

    onChange(e);
  };

  (0, react_1.useEffect)(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return (0, jsx_runtime_1.jsxs)(styles_1.Container, Object.assign({
    isDisabled: isDisabled
  }, {
    children: [(0, jsx_runtime_1.jsx)(styles_1.Input, {
      checked: isChecked,
      disabled: isDisabled,
      onChange: handleOnChange,
      ref: checkboxRef
    }, void 0), (0, jsx_runtime_1.jsx)(styles_1.StyledCheckbox, {
      checkboxBg: checkboxBg,
      checkboxBgActive: checkboxBgActive,
      checkboxBgDisabled: checkboxBgDisabled,
      checkboxBorderColor: checkboxBorderColor,
      checkMarkColor: checkMarkColor
    }, void 0), label && (0, jsx_runtime_1.jsx)(styles_1.Label, {
      children: label
    }, void 0)]
  }), void 0);
};

exports.default = Checkbox;